<template>
    <div style="display: flex;">
        <quick-customer-form v-ref:quick-customer-form
                             :title="'Cadastrar ' + itemName"
                             :with-form="withForm"
                             :show-form="withForm"
                             :user-id="userId"
                             mode="create"
                             :created="customerCreated"></quick-customer-form>
        <div style="width: 100%">
            <form-remote-select v-ref:select
                                :model.sync="model"
                                :placeholder="placeholder || label || itemName"
                                :has-label="hasLabel"
                                url="/customers"
                                :query="scope"
                                :url-data="{restricted: true}"
                                :template-result="templateResult"
                                :process-result="processResult"
                                :head-options="extraOptions">
                <div slot="label" v-if="hasLabel">
                    {{ label || itemName }}

                    <!--
                    <span v-if="model">
                        <a href="javascript:;" class="pull-right" v-quick-view-customer :data-id="model">
                            Ver
                            <i class="fa fa-external-link"></i>
                        </a>
                    </span>
                    -->
                </div>
            </form-remote-select>
        </div>
        <!--
        <div style="padding-top: 24px; margin-left: 5px" v-if="model">
            <button type="button" class="btn blue" v-quick-view-customer :data-id="model" title="Visualizar" v-tooltip>
                <i class="fa fa-eye"></i>
            </button>
        </div>
        -->
    </div>
</template>
<script type="text/babel">
    const { string } = require('sci/std')
    const R = require('ramda')

    export default {
        components: {
            QuickCustomerForm: require('components/customer/QuickForm.vue')
        },
        props: {
            scope: {
                type: Object,
                default () {
                    return {}
                }
            },
            model: {
                twoWay: true
            },
            itemName: {
                type: String,
                default: 'Cliente'
            },
            hasLabel: {
                type: Boolean,
                default: true
            },
            label: {
                type: String,
                default: null
            },
            placeholder: {
                type: String,
                default: null
            },
            withForm: {
                type: Boolean,
                default: false
            },
            form: {
                type: Object,
                default: null
            },
            allowCreation: {
                type: Boolean,
                default: true
            },
            userId: {
                default: null
            },
            onCustomerCreated: {
                type: Function,
                default: null
            }
        },
        data () {
            return {
                formData: null
            }
        },
        ready () {
            this.formData = this.form || this.scope
        },
        methods: {
            customerCreated (customer) {
                this.model = customer.id
                if (this.onCustomerCreated) {
                    this.onCustomerCreated(customer)
                }
            },
            open (name) {
                this.$refs.quickCustomerForm.show({
                    name,
                    type: R.pathOr(1, ['type'], this.formData),
                    owner: R.pathOr(false, ['owner'], this.formData),
                    interested: R.pathOr(false, ['interested'], this.formData),
                    building_builder: R.pathOr(false, ['building_builder'], this.formData),
                    building_developer: R.pathOr(false, ['building_developer'], this.formData),
                    building_administrator: R.pathOr(false, ['building_administrator'], this.formData),
                    building_manager: R.pathOr(false, ['building_manager'], this.formData)
                })
            },
            templateResult (item, container) {
                if (item.__create) {
                    container.classList.add('bg-warning')
                    container.classList.add('new-neighborhood-option')

                    container.addEventListener('click', () => {
                        this.$refs.select.close()
                        this.open(item.name)
                    })

                    let statement = this.itemName.toUpperCase()

                    if (item.name) {
                        statement = `<b>${item.name}</b>`
                    }

                    return `
                        <div style="padding: 6px; margin-left: -6px; margin-right: -6px; cursor: pointer">
                            Não encontrou?
                            <button class="btn btn-sm orange" style="text-transform: uppercase">cadastrar ${statement}</button>
                        </div>
                    `
                }

                const subtitle = []

                if (item.owner) {
                    subtitle.push('<span class="label label-info label-sm">Proprietário</span>')
                }

                if (item.interested) {
                    subtitle.push('<span class="label label-info label-sm">Interessado</span>')
                }

                if (item.building_developer) {
                    subtitle.push('<span class="label label-info label-sm">Incorporadora</span>')
                }

                if (item.building_builder) {
                    subtitle.push('<span class="label label-info label-sm">Construtora</span>')
                }

                if (item.building_manager) {
                    subtitle.push('<span class="label label-info label-sm">Administradora</span>')
                }

                if (item.has_properties) {
                    const v = string.plural(item.has_properties, 'imóveis', 'imovel')
                    subtitle.push(`<span class="label label-info label-sm">${item.has_properties} ${v}</span>`)
                }

                return `
                    <div>
                        <div>${item.name}</div>
                        <div style="opacity: .7">${item.contact_line.join(' ')}</div>
                        <div>${subtitle.join(' ')}</div>
                    </div>
                `
            },
            processResult (items, term) {
                return items.filter(_ => _.id !== -1)
            },
            extraOptions (items, term) {
                if (this.allowCreation && this.$can('add.customers')) {
                    return [
                        {
                            id: -1,
                            disabled: true,
                            __create: true,
                            name: term,
                            text: term
                        }
                    ]
                }

                return []
            }
        },
        computed: {},
        watch: {
            scope () {
                this.formData = this.form || this.scope
            },
            form () {
                this.formData = this.form || this.scope
            }
        }
    }

</script>



// WEBPACK FOOTER //
// Picker.vue?2c38bb5b